import compareFindRecipientPersonaType from 'owa-recipient-common/lib/utils/compareFindRecipientPersonaType';
import { action } from 'satcheljs/lib/legacy';
import removeReadWriteRecipient from 'owa-readwrite-recipient-well/lib/actions/removeReadWriteRecipient';
export default action('removePersonaFromWell')(function removePersonaFromWell(targetRecipientWell, personaToRemove) {
    var elementToRemove = targetRecipientWell.recipients.filter(function (value) {
        return compareFindRecipientPersonaType(value.persona, personaToRemove);
    });
    if (elementToRemove && elementToRemove.length > 0) {
        if (elementToRemove[0].blockRecipientRemoval) {
            return;
        }
        var indexToRemove = targetRecipientWell.recipients.indexOf(elementToRemove[0]);
        removeReadWriteRecipient(targetRecipientWell, indexToRemove);
    }
});
//# sourceMappingURL=removePersonaFromWell.js.map